export const siteSettings = {
  name: "Finwise",
  link: "https://finwisevest.com",
  email: "support@finwisevest.com",
  appLink: "https://app.finwisevest.com",
};
